export const DEVICES_RECEIVED = 'DEVICES_RECEIVED';
